<template>
    <div>
        <DialogoTerminos ref="dialogoTerminos" />
        <v-card flat :max-width="($vuetify.breakpoint.mdAndUp) ? '430px' : '380px'"
            :class="($vuetify.breakpoint.xsOnly) ? 'px-5' : ''">
            <v-form @submit.prevent="submit">
                <ValidationObserver ref="obs" v-slot="{ invalid }">
                    <v-row class="d-flex flex-row justify-center align-center">
                        <v-col cols="12" md="12" class="font-weight-regular primary--text text-h5">
                            INGRESÁ TUS DATOS
                        </v-col>
                        <v-col cols="12" md="12" class="d-flex flex-column">
                            <ValidationProvider rules="required|numeric" v-slot="v">
                                <v-text-field outlined v-model="nroafi" hide-spin-buttons type="text"
                                    @keydown="preventArrowKeys" :error-messages="v.errors"
                                    @keypress="if (!/^\d$/.test($event.key)) $event.preventDefault()"
                                    :maxlength="6" @input="onInputMatricula" label="Nº Matricula"
                                    @blur="onBlurMatricula">
                                </v-text-field>
                            </ValidationProvider>
                            <ValidationProvider rules="required|numeric|minmax:7,8|min_doc" v-slot="v">
                                <v-text-field outlined v-model="nrodoc" hide-spin-buttons type="text"
                                    @keydown="preventArrowKeys" :error-messages="v.errors"
                                    @keypress="if (!/^\d$/.test($event.key)) $event.preventDefault()"
                                    @change="onChangeDocumento" :maxlength="8" label="Nº Documento" />
                            </ValidationProvider>

                            <vue-turnstile v-if="showTurnstile && check"
                                class="d-flex ma-0 pa-0 justify-center align-center" :key="componentKey"
                                :autoReset='true' theme="light" :siteKey="siteKey" @verified="token = $event" />
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider name="terminos" rules="required" v-slot="v">
                                <v-checkbox v-model="check" color="primary" value="true"
                                    class="font-weight-regular py-0 text-body-2" :error-messages="v.errors">
                                    <template v-slot:label>
                                        <div class="black--text">
                                            He leído y acepto los <span
                                                class="font-weight-bold text-body-2 text-uppercase primary--text"
                                                @click.stop.prevent="abrirDialogoTerminos"
                                                style="cursor: pointer;">términos
                                                y condiciones</span>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row class="text-center justify-center py-0">
                        <v-col cols="12" md="12" class="ma-0 py-0">
                            <v-btn :disabled="invalid || !showTurnstile || !check || !token" block
                                class="pa-6 rounded-lg" color="primary" type="submit" elevation="0"
                                :loading="loadBtn" x-large>
                                ACEPTAR
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="solicitada">
                        <v-col>
                            <v-alert v-if="(errorRecover !== '') && (errorRecover == 0)"
                                class="font-weight-regular text-body-2 d-flex flex-column align-center justify-center text-center"
                                dense color="success" elevation="0" dark>
                                <div class="font-weight-bold">
                                    Matricula Nro. {{ matriculaIngresada }}
                                </div>
                                <div style="position: absolute; top: 8px; left: 8px;">
                                    <v-icon color="white">mdi-check-circle-outline</v-icon>
                                </div>
                                <div class="ma-1" style="margin-top: 32px;"
                                    :class="($vuetify.breakpoint.xsOnly) ? 'py-5' : ''">
                                    Tu solicitud de nueva contraseña ha sido enviada a:
                                    <b><br>{{ emailAfi }}</b>
                                </div>
                                <div class="my-5 d-flex flex-column align-center justify-center text-center">
                                    Si éste no es tu mail comunicate a:
                                    <br>
                                    <div class="font-weight-bold">
                                        validaciones@cajapsipba.org.ar
                                    </div>
                                    Revisá la carpeta de SPAM
                                </div>
                            </v-alert>
                            <v-alert v-if="errorRecover == 1" class="font-weight-regular text-body-2" dense
                                icon="mdi-alert-circle-outline" color="orange darken-3" elevation="0" dark>
                                <div class="ma-1 d-flex flex-column align-center justify-center">
                                    {{ emailAfi }}
                                </div>
                            </v-alert>
                            <v-alert v-if="errorRecover == 2" class="font-weight-regular text-body-2" dense
                                icon="mdi-alert-circle-outline" color="orange darken-3" elevation="0" dark>
                                {{ emailAfi }}
                                <div class="my-1" v-if="emailAfi.includes('procesado')">
                                    <a href="https://www.cajapsipba.org.ar/delegaciones.asp" target="_blank"
                                        class="font-weight-bold white--text">
                                        Ver delegaciones
                                    </a>
                                </div>
                            </v-alert>
                            <v-btn
                                v-if="errorRecover == 2 && (!(emailAfi.includes('No pudimos') || emailAfi.includes('distrito') || emailAfi.includes('Delegación Distrital')))"
                                @click="irAPreAfi" color="primary" block class="pa-6 rounded-lg elevation-0">
                                COMPLETAR FORMULARIO
                            </v-btn>
                        </v-col>
                    </v-row>
                </ValidationObserver>
            </v-form>
        </v-card>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapGetters, mapActions } from 'vuex';
import DialogoTerminos from '@/components/dialogos/DialogoTerminos.vue';
import VueTurnstile from '@gaviti/vue-turnstile';

export default {
    name: 'FormRecuperar',
    components: {
        ValidationObserver,
        ValidationProvider,
        DialogoTerminos,
        VueTurnstile,
    },
    data() {
        return {
            solicitada: false,
            check: false,
            componentKey: 0,
            token: null,
            siteKey: process.env.VUE_APP_TURNSTILE_SITEKEY || '0x4AAAAAAALfPrTf0FZmBPRX',
            nroafi: '',
            nrodoc: '',
            showTurnstile: false,
            matriculaIngresada: '',
            loadBtn: false,
        };
    },
    computed: {
        ...mapGetters('notificaciones', ['loading', 'mensaje']),
        ...mapGetters(['mensajeReestablecerPass', 'emailAfi', 'errorRecover']),
    },
    methods: {
        ...mapActions(['recoverPassword']),
        ...mapActions('notificaciones', ['showSnack']),

        forceRerender() {
            this.componentKey += 1;
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        onBlurMatricula() {
            this.solicitada = false;
            this.showTurnstile = this.nroafi && this.nroafi.length <= 6;
        },
        onInputMatricula() {
            // hook reservado para validaciones futuras del campo nroafi
        },
        onChangeDocumento() {
            // hook reservado para validaciones futuras del campo nrodoc
        },
        irAPreAfi() {
            this.$router.push('/preafiliacion').catch(() => { });
        },
        abrirDialogoTerminos() {
            this.$refs.dialogoTerminos.abrirDialogo();
        },
        submit() {
            const vm = this;
            vm.$refs.obs.validate().then(result => {
                if (result) {
                    if (vm.token !== null) {
                        vm.loadBtn = true;
                        vm.matriculaIngresada = vm.nroafi;
                        vm.recoverPassword({
                            nroafi: parseInt(vm.nroafi),
                            nrodoc: parseInt(vm.nrodoc),
                            captcha: vm.token,
                            function(res) {
                                vm.nroafi = null;
                                vm.nrodoc = null;
                                vm.token = null;
                                vm.check = false;
                                vm.forceRerender();
                                vm.solicitada = true;
                            },
                        }).finally(() => {
                            vm.loadBtn = false;
                        });
                    } else {
                        vm.showSnack({
                            message: 'Por favor, completa el CAPTCHA antes de enviar el formulario.',
                            type: '400',
                        });
                    }
                }
                this.check = false;
            });
        },
    },
};
</script>
